/**
 * This is a Context that we use locally within the Integrations set of components to make Org Config
 * available to both "list" and "editor" pages and their children
 */
import { createContext } from 'react';
import { integrationsOrgConfig } from 'src/actions/integrations/integrationsOrgConfigResource';

export const OrgConfigContext = createContext<integrationsOrgConfig>({});
